<template>
    <div>
        Whatsapp credit has dropped to "<strong>{{ $_.get(activity, "payload.balance") }}₺ </strong>".
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappCreditLow",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
